import type { SupportedIcon } from "@/components/ui/icon";
import type { AnyDetailedListing } from "@/lib/types";

type MonetaryValue = bigint | number | null | undefined;

function toNumberSafe(value: MonetaryValue): number {
  if (value === null || value === undefined) {
    return 0;
  }

  return typeof value === "bigint" ? Number(value) : value;
}

/** Total asking price (business + property). Handles bigint/number mix from tRPC serialization. */
export function getTotalAskingPrice(listing: {
  askingPrice?: MonetaryValue;
  propertyAskingPrice?: MonetaryValue;
}): number {
  return (
    toNumberSafe(listing.propertyAskingPrice) + toNumberSafe(listing.askingPrice)
  );
}

export function hasPropertyAskingPrice(listing: {
  propertyAskingPrice?: MonetaryValue;
}): boolean {
  return toNumberSafe(listing.propertyAskingPrice) > 0;
}

export type ListingStatusColor =
  | "green"
  | "purple"
  | "blue"
  | "orange"
  | "red"
  | "black";

export function getIconForListingStatus(
  status: AnyDetailedListing["status"],
): SupportedIcon {
  switch (status) {
    case "DRAFT":
      return "Pencil2";
    case "ARCHIVED":
    case "HIDDEN":
      return "EyeOff";
    case "PENDING_IMPORT":
      return "Processing";
    case "PUBLISHED":
    case "FOR_SALE":
      return "Sale";
    case "REVIEWING_OFFERS":
      return "Search";
    case "PENDING_CONTRACT":
      return "Processing";
    case "UNDER_CONTRACT":
      return "FountainPenTip";
    case "SOLD":
      return "CheckSolid";
    case "REVIEWING":
      return "Processing";
    case "REJECTED":
    case "DELETED":
      return "XClose";
  }
}

export function getThemeColorForListingStatus(
  status: AnyDetailedListing["status"],
): ListingStatusColor {
  switch (status) {
    case "DRAFT":
      return "blue";
    case "PENDING_IMPORT":
    case "REVIEWING":
      return "orange";
    case "PUBLISHED":
    case "FOR_SALE":
      return "green";
    case "REVIEWING_OFFERS":
      return "purple";
    case "PENDING_CONTRACT":
      return "blue";
    case "UNDER_CONTRACT":
      return "orange";
    case "SOLD":
      return "red";
    case "REJECTED":
    case "DELETED":
      return "red";
    case "ARCHIVED":
    case "HIDDEN":
      return "black";
    default:
      return "black";
  }
}
